import React from 'react';
import styles from './styles.module.sass';
import cx from 'classnames';

export default function Label(prop) {
  const {className, children} = prop;
  return (
    <div className={cx(styles.box, className)}>
      <div className={styles.text}>{children}</div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/common/Label/Label.jsx